
import { BrowserRouter } from 'react-router-dom'
import { Suspense } from 'react'
import { AppRoutes } from './router'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>}>
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  )
}

export default App
